/* eslint-disable no-param-reassign */
import produce from 'immer';

import { LOAD_LEVELPATH_REQUEST } from '../actions/levelpathAction';

const initialState = {
  sublevels: null
};

const levelpathReducer = (state = initialState, action) => {
  switch (action.type) {

    case LOAD_LEVELPATH_REQUEST: {
      const { sublevels } = action.payload;
      return produce(state, (draft) => {
        draft.sublevels = sublevels;
      });
    }

    default: {
      return state;
    }
  }
};

export default levelpathReducer;
